import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Chip,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Breadcrumbs,
  Container,
  Divider
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";
import SearchField from "../mui/SearchField";
import CustomDropdownMenu from "../mui/dropdown";
import ProgressDialog from "../mui/progressdialog";
import AlertDialog from "../mui/dialog";
import { loadAllGiftVendors } from "../data/API";
import { getRegions } from "../data/models/GlobalAdmin";
import VendorGifts from "./VendorGifts";
import VendorGiftDetails from "./VendorGiftDetails";
import { IMAGE_BASE_URL } from "../data/API_LINKS";

const TITLE_HOME = "Vendors";
const TITLE_PRIZES = TITLE_HOME + " > Prizes";
const TITLE_PRIZE_DETAILS = TITLE_PRIZES + " > Prize Details";

export default function PrizeVendors() {
  const [vendorsList, setVendorsList] = React.useState(null);
  const [selectedVendor, setSelectedVendor] = React.useState(null);
  const [region, setRegion] = React.useState("");
  const [subRegion, setSubRegion] = React.useState("");
  const [regionsList, setRegionsList] = React.useState([]);
  const [subRegionsList, setSubRegionsList] = React.useState([]);
  const [isWarning, setIsWarning] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [menus, setGivenGifts] = React.useState(null);
  const [state, setState] = React.useState(TITLE_HOME);

  const onVendorsListItemClickCallback = (data) => {
    console.log(data);
    setSelectedVendor(data);
    setState(TITLE_PRIZES);
  };

  const onBackClickListener = () => {
    if (state !== TITLE_HOME) {
      if (state === TITLE_PRIZES) {
        setState(TITLE_HOME);
      } else {
        setState(TITLE_PRIZES);
      }
    }
  };

  const onItemsSelection = (items) => {
    setGivenGifts(items);
    console.log(items);
    setState(TITLE_PRIZE_DETAILS);
  };

  function loadData() {
    console.log('loadDataLoading');
    setIsLoading(true);
    setIsWarning(false);
   
    loadAllGiftVendors((err, data) => {
      if (err) {
        setIsLoading(false);
        console.log(err);
        setIsWarning(true);
      } else {
        console.log(data);
        setVendorsList(data);
        getRegions((error2, regions) => {
          if (error2) {
            setIsWarning(true);
            console.log(error2);
            setIsLoading(false);
            return;
          } else {
            setIsLoading(false);
            setIsWarning(false);
            setRegionsList(regions);
            setSubRegionsList(regions[0].subregions);
            setRegion(regions[0].name);
            setSubRegion(regions[0].subregions[0]);
          }
        });
      }
    });
  }

  React.useEffect(() => {
    loadData();
  }, []);

  function getRegionFromName(n) {
    var region = null;
    console.log(regionsList);
    for (let i = 0; i < regionsList.length; i++) {
      if (n === regionsList[i].name) {
        region = regionsList[i];
      }
    }
    console.log("getRegionFromName");
    console.log(region);
    return region;
  }

  function getNamesFromRegions(list) {
    return list?.map((data) => {
      return data.name;
    });
  }

  function onRegionSelection(selectedNamedRegion) {
    setRegion(selectedNamedRegion);
    var sList = getRegionFromName(selectedNamedRegion).subregions;
    setSubRegionsList(sList);
    setSubRegion(sList[0]);
  }

  function onSubRegionSelection(selectedNamedSubRegion) {
    setSubRegion(selectedNamedSubRegion);
  }

  const VendorsTable = () => {
    const [query, setQuery] = React.useState("");

    const getFilteredList = (list) => {
      if (!list) return [];
      
      return list.filter((vendor) => {
        // Apply region filter
        const regionMatch = !region || vendor.region === region || region==='Entire Malaysia'; 
        
        // Apply subregion filter
        const subRegionMatch = !subRegion || vendor.subregion === subRegion || subRegion==='All'; 
        
        // Apply search query filter (case insensitive)
        const searchMatch = !query || 
          vendor.full_name.toLowerCase().includes(query.toLowerCase()) ||
          vendor.email.toLowerCase().includes(query.toLowerCase()) ||
          vendor.phone.toLowerCase().includes(query.toLowerCase());
        
        // All filters must pass
        return regionMatch && subRegionMatch && searchMatch;
      });
    };


    return (
      <Card elevation={2} sx={{ backgroundColor: "#fafafa" }}>
        <CardContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <Box 
              display="flex" 
              flexDirection={{ xs: 'column', md: 'row' }}
              gap={2}
              alignItems="center"
            >
              <Box display="flex" gap={2} width={{ xs: '100%', md: '60%' }}>
                <CustomDropdownMenu
                  onSelection={onRegionSelection}
                  width={170}
                  label={"Region"}
                  value={region}
                  list={getNamesFromRegions(regionsList)}
                />
                <CustomDropdownMenu
                  onSelection={onSubRegionSelection}
                  width={170}
                  label={"Sub Region"}
                  value={subRegion}
                  list={subRegionsList}
                />
              </Box>
              <Box width={{ xs: '100%', md: '40%' }}>
                <SearchField setQuery={setQuery} query={query} />
              </Box>
            </Box>
            
            <TableContainer component={Paper} elevation={1}>
              <Table sx={{ minWidth: '100%' }} aria-label="vendors table">
                <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "600" }} align="left">
                      Vendor
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600" }} align="left">
                      Email
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600" }} align="left">
                      Phone
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600" }} align="left">
                      Region
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600" }} align="left">
                      Sub Region
                    </TableCell>
                    <TableCell sx={{ fontWeight: "600" }} align="left">
                      Gifts
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getFilteredList(vendorsList)?.map((rowData, key) => (
                    <TableRow
                      onClick={() => onVendorsListItemClickCallback(rowData)}
                      key={key}
                      sx={{ 
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { backgroundColor: "#fff8e1", cursor: "pointer" },
                        transition: "background-color 0.2s ease"
                      }}
                    >
                      <TableCell>
                        <Box display="flex" alignItems="center" gap={2}>
                          <Avatar
                            src={IMAGE_BASE_URL + rowData.profile_img}
                            alt={rowData.full_name}
                            sx={{ width: 40, height: 40 }}
                          />
                          <Typography color="error" fontWeight="500">
                            {rowData.full_name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="left">{rowData.email}</TableCell>
                      <TableCell align="left">{rowData.phone}</TableCell>
                      <TableCell align="left">{rowData.region}</TableCell>
                      <TableCell align="left">{rowData.subregion}</TableCell>
                      <TableCell align="left">
                        <Chip 
                          label={`${rowData.prizes?.length} ${rowData.prizes?.length > 1 ? 'Items' : 'Item'}`}
                          size="small"
                          color="error"
                          variant="outlined"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </CardContent>
      </Card>
    );
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <ProgressDialog msg={"Loading Prizes"} visible={isLoading} />
      <AlertDialog
        warningMessage={
          "Something went wrong! Please refresh page or check your internet connection"
        }
        visible={isWarning}
      />
      
      <Box mb={3}>
        <Card elevation={1} sx={{ backgroundColor: "#f5f5f5" }}>
          <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
            <Box display="flex" alignItems="center">
              <IconButton 
                color="error"
                onClick={() => setState(TITLE_HOME)}
                size="small"
              >
                <HomeIcon />
              </IconButton>
              
              {state !== TITLE_HOME && (
                <IconButton 
                  color="error"
                  onClick={onBackClickListener}
                  size="small"
                  sx={{ mx: 1 }}
                >
                  <ArrowBackIosIcon />
                </IconButton>
              )}
              
              <Breadcrumbs aria-label="breadcrumb" separator="›">
                {state.split(" > ").map((item, index) => (
                  <Typography 
                    key={index}
                    color={index === state.split(" > ").length - 1 ? "error" : "text.secondary"}
                    fontWeight={index === state.split(" > ").length - 1 ? 600 : 400}
                  >
                    {item}
                  </Typography>
                ))}
              </Breadcrumbs>
            </Box>
          </CardContent>
        </Card>
      </Box>
      
      <Box
        sx={{
          height: "calc(100vh - 180px)",
          overflow: "auto",
          borderRadius: 1,
        }}
      >
        {state === TITLE_HOME ? (
          <VendorsTable />
        ) : state === TITLE_PRIZES ? (
          <VendorGifts 
            vendor={selectedVendor} 
            onItemsSelection={onItemsSelection} 
            loadData={loadData} 
            onBackClickListener={onBackClickListener} 
          />
        ) : state === TITLE_PRIZE_DETAILS ? (
          <VendorGiftDetails givenGifts={menus} />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography variant="h5" color="error">404 Not Found</Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
}